const binding = { modules: {}, dataActions: {} };

    (binding.modules['video-player'] = {
        c: () => require('@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'video-player',
        p: 'video-player',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['@msdyn365-commerce-modules|video-player|modules|video-player|video-player'] = {
                c: () => require('@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player.view.js'),
                cn: '@msdyn365-commerce-modules-video-player-video-player'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };